export default __webpack_public_path__ + "static/media/referAFriend@2x.7c6c4265.png";